module.exports = __webpack_public_path__ + "static/media/Corner Head.e0108816.jpg";